module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"footer.close":"Fermer"}}')
  delete Component.options._Ctor
}
